import script from "./WPatientSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WPatientSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./WPatientSidebar.vue?vue&type=style&index=0&id=ffed03b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffed03b8"]])

export default __exports__